import { makeStyles } from '@material-ui/core/styles'

import { COLORS } from 'styles'

const useStyles = makeStyles({
  title: {
    color: COLORS.FONT,
  },
  divider: {
    backgroundColor: COLORS.BASE,
  },
  tableWrap: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
    '& .MuiPaper-root': {
      width: '100%',
      overflowX: 'hidden',
    },
    '& .MuiTable-root': {
      width: '100%',
      tableLayout: 'fixed',
    },
    '& .MuiTableCell-root': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  // Figma: Pie Chart - Donut with Text
  donutCard: {
    boxSizing: 'border-box',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 16,
    background: '#FFFFFF',
    border: '1px solid #E4E4E7',
    borderRadius: 6,
    overflow: 'visible',
  },
  donutInner: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '24px 0',
    gap: 24,
    overflow: 'visible',
  },
  donutHeader: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 6,
  },
  donutHeaderText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 16,
    minWidth: 0,
  },
  donutTitle: {
    margin: 0,
    fontFamily: "'Raleway', sans-serif",
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '24px',
    color: '#1D1D1B',
  },
  donutPeriod: {
    fontFamily: "'Raleway', sans-serif",
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: '#6D6D6D',
  },
  donutChartWrap: {
    position: 'relative',
    boxSizing: 'border-box',
    width: '100%',
    height: 192,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 24px',
    marginTop: 16,
    marginBottom: 16,
    overflow: 'visible',
    zIndex: 1,
  },
  donutPie: {
    position: 'relative',
    width: 192,
    height: 192,
    zIndex: 2,
    overflow: 'visible',
  },
  donutCenter: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 0,
    pointerEvents: 'none',
    zIndex: 1,
  },
  donutCenterValue: {
    fontFamily: "'Raleway', sans-serif",
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '36px',
    textAlign: 'center',
    color: '#1D1D1B',
  },
  donutCenterLabel: {
    fontFamily: "'Raleway', sans-serif",
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '16px',
    textAlign: 'center',
    color: '#1D1D1B',
  },
  // Figma: Referencias — row, centered, gap 36
  donutLegend: {
    listStyle: 'none',
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 38,
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    gap: 36,
  },
  // Figma: Datos — row, gap 16, height 38. Width follows content so
  // values like "9.6 h (60%)" stay fully visible (Figma mock used "92 h").
  donutLegendItem: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 0,
    gap: 24,
    minHeight: 48,
    borderRadius: 8,
    flex: 'none',
    flexGrow: 0,
    flexShrink: 0,
  },
  donutLegendBar: {
    width: 6,
    height: 40,
    flex: 'none',
    flexShrink: 0,
    marginLeft: 8,
    marginRight: 8,
    borderRadius: 999,
  },
  donutLegendCopy: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 0,
    gap: 8,
    flex: 'none',
  },
  donutLegendValue: {
    display: 'block',
    margin: 0,
    fontFamily: "'Raleway', sans-serif",
    fontStyle: 'normal',
    fontSize: 20,
    lineHeight: '24px',
    letterSpacing: '-0.022em',
    color: '#353535',
    whiteSpace: 'nowrap',
  },
  donutLegendHours: {
    fontWeight: 700,
  },
  donutLegendPercent: {
    fontWeight: 400,
    marginLeft: 4,
  },
  donutLegendName: {
    display: 'block',
    margin: 0,
    marginTop: 2,
    fontFamily: "'Raleway', sans-serif",
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '18px',
    color: '#1D1D1B',
    whiteSpace: 'nowrap',
  },
  donutTooltip: {
    position: 'relative',
    zIndex: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    padding: '10px 12px',
    background: '#FFFFFF',
    border: '1px solid #E4E4E7',
    borderRadius: 6,
    boxShadow: '0 4px 12px rgba(29, 29, 27, 0.12)',
  },
  donutTooltipBar: {
    width: 6,
    height: 36,
    borderRadius: 999,
    flexShrink: 0,
  },
  donutTooltipCopy: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
    paddingLeft: 8,
  },
  donutTooltipValue: {
    fontFamily: "'Raleway', sans-serif",
    fontSize: 16,
    lineHeight: '20px',
    letterSpacing: '-0.022em',
    color: '#353535',
    whiteSpace: 'nowrap',
  },
  donutTooltipName: {
    fontFamily: "'Raleway', sans-serif",
    fontWeight: 400,
    fontSize: 13,
    lineHeight: '16px',
    color: '#1D1D1B',
    maxWidth: 220,
  },
  donutLoading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: 192,
  },
  donutEmpty: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: 192,
    fontFamily: "'Raleway', sans-serif",
    fontSize: 14,
    color: '#6D6D6D',
  },
})

export { useStyles }
